import React from 'react';
import Image from 'next/image';
import { StyledPlatofrmsHero } from './platformsHero.styles';

export const PlatformsHero = () => {
    return (
        <StyledPlatofrmsHero>
            <div className="hero-wrapper">
                <h1>Our Brackets Work on Any Website and E-commerce Store</h1>
                <h2>Our brackets can be easily embedded on any website, blog, e-commerce platform, or website builder.</h2>
                <Image className="icons left" src='/assets/platforms-icons-left.svg' alt='platform icons' width={424} height={303} />
                <Image className="icons right" src='/assets/platforms-icons-right.svg' alt='platform icons' width={409} height={293} />
            </div>
        </StyledPlatofrmsHero>
    );
};
